export default __webpack_public_path__ + "static/media/battery-3.8d0bfd76.svg";